import { useContext } from 'react';

import PayloadPhaseContext from '../../context/materialcapture/PayloadPhaseContext';

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import SendSharpIcon from '@mui/icons-material/SendSharp';

const PayloadPhaseForm = () => {
  const { 
    payloadPhaseData, setPayloadPhaseData, handleSubmit, initialValues, formErrors
  } = useContext(PayloadPhaseContext);

  return(
    <Grid container spacing={1} mt={1}>
      <Grid item xs={6}>
        <Autocomplete
          value={payloadPhaseData?.payloadName}
          onChange={(e, newValue) => 
            setPayloadPhaseData(prev => ({
              ...prev,
              payloadName: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setPayloadPhaseData(prev => ({
              ...prev,
              payloadName: newValue
            }))
          }
          options={initialValues?.payloadNameArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Payload Name *" 
              placeholder="Type to search Payload Name..." 
              error={'payloadName' in formErrors}
              helperText={formErrors['payloadName']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={payloadPhaseData?.payloadType}
          onChange={(e, newValue) => 
            setPayloadPhaseData(prev => ({
              ...prev,
              payloadType: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setPayloadPhaseData(prev => ({
              ...prev,
              payloadType: newValue
            }))
          }
          options={initialValues?.payloadTypeArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Payload Type *" 
              placeholder="Type to search payload Type..." 
              error={'payloadType' in formErrors}
              helperText={formErrors['payloadType']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={payloadPhaseData?.reporter}
          onChange={(e, newValue) => 
            setPayloadPhaseData(prev => ({
              ...prev,
              reporter: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setPayloadPhaseData(prev => ({
              ...prev,
              reporter: newValue
            }))
          }
          options={initialValues?.reporterArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Reporter *" 
              placeholder="Type to search Reporter..." 
              error={'reporter' in formErrors}
              helperText={formErrors['reporter']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={payloadPhaseData?.payloadBatchNumber}
          onChange={(e, newValue) => 
            setPayloadPhaseData(prev => ({
              ...prev,
              payloadBatchNumber: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setPayloadPhaseData(prev => ({
              ...prev,
              payloadBatchNumber: newValue
            }))
          }
          options={initialValues?.payloadBatchNumberArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Payload Batch Number *" 
              placeholder="Type to search Payload Batch Number..." 
              error={'payloadBatchNumber' in formErrors}
              helperText={formErrors['payloadBatchNumber']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Payload Phase Unique ID *"
          name='payloadPhaseUniqueId'
          value={payloadPhaseData?.payloadPhaseUniqueId}
          onChange={e => 
            setPayloadPhaseData(prev => ({
              ...prev,
              payloadPhaseUniqueId: e.target.value
            }))
          }
          helperText={formErrors['payloadPhaseUniqueId']}
          error={'payloadPhaseUniqueId' in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Concentration (μg/mL) *"
          name='concentration'
          value={payloadPhaseData?.concentration}
          onChange={e => 
            setPayloadPhaseData(prev => ({
              ...prev,
              concentration: e.target.value
            }))
          }
          helperText={formErrors['concentration']}
          error={'concentration' in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={payloadPhaseData?.operatorArray || []}
          onChange={(e, newValue) => 
            setPayloadPhaseData(prev => ({
              ...prev,
              operatorArray: newValue
            }))
          }
          onInputChange={(e, newInputValue, reason) => {
            if (reason === "createOption" && newInputValue.trim()) {
              setPayloadPhaseData((prev) => ({
                ...prev,
                operatorArray: [
                  ...(prev.operatorArray || []),
                  newInputValue
                ],
              }));
            }
          }}
          options={initialValues?.operatorArray || []}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Operator *" 
              placeholder="Type to search Operator..." 
              error={'operator' in formErrors}
              helperText={formErrors['operator']}
            />
          )}
          multiple
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={payloadPhaseData?.encapsulantBufferId}
          onChange={(e, newValue) => 
            setPayloadPhaseData(prev => ({
              ...prev,
              encapsulantBufferId: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setPayloadPhaseData(prev => ({
              ...prev,
              encapsulantBufferId: newValue
            }))
          }
          options={initialValues?.bufferUniqueIdArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Encapsulant Buffer Unique ID *" 
              placeholder="Type to search Buffer Unique ID..." 
              error={'encapsulantBufferId' in formErrors}
              helperText={formErrors['encapsulantBufferId']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Encapsulant Buffer Acronym"
          name='encapsulantBufferAcronym'
          value={initialValues?.encapsulantBufferAcronym}
          fullWidth
          disabled
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Buffer Concentration"
          name='bufferConcentration'
          value={initialValues?.bufferConcentration}
          helperText={formErrors['bufferConcentration']}
          error={'bufferConcentration' in formErrors}
          type='number'
          disabled
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Target pH"
          name='targetPH'
          value={initialValues?.targetPH}
          helperText={formErrors['targetPH']}
          error={'targetPH' in formErrors}
          type='number'
          disabled
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <Stack direction="row" spacing={1} justifyContent="flex-end" mr={1}>
          <Button 
            variant="contained" 
            endIcon={<SendSharpIcon />} 
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default PayloadPhaseForm;